/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 10/01/2014
 * Time: 08:09
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services')
    .factory('GiftItemView',
        ["$sce", "$dialog", "GiftItemData", "GiftItem", "$filter", "GiftItemSrv", "CurrencyManager", "gettextCatalog", "NumberSeparatorType",
            function ($sce, $dialog, GiftItemData, GiftItem, $filter, GiftItemSrv, CurrencyManager, gettextCatalog, NumberSeparatorType) {

                var GiftItemView = function (giftItem, giIndex, billPosition, saleView) {
                    this.giIndex = giIndex; //model index
                    this.posView = (saleView) ? saleView.posView : null;
                    this.saleView = saleView;
                    this.serviceView = null;
                    this.paymentSaleView = null;
                    this.categoryType = "giftItem";
                    this.categoryTypeSortOrder = 4;
                    this.code = null;
                    this.isUsed = false;
                    this.isCanceled = false;
                    this.closingDate = null;
                    this.price = 0;
                    this.priceHT = 0;
                    this.vat = 0;
                    this.vatCode = "T0"; //vat 0
                    this.originalPrice = 0;
                    this.originalPriceInput = "";
                    this.originalPriceSelect = 50;
                    this.discountPercent = 0;
                    this.hrView = null;
                    this.validityDate = null;
                    this.validityDateStr = null;
                    this.editionType = "";  //printOnTicket / manual / email / delivery / delivered
                    this.customerView = null;//beneficiary
                    this.customerLabel = "";//beneficiary
                    this.billPosition = billPosition;//position inside sale ->
                    this.barcodeData = "";//write only
                    this.message = "";
                    this.messageTitle = "";
                    this.imageUrl = "";
                    this.comment = "";

                    if (giftItem) {
                        this.loadDataFrom(giftItem);
                    }
                }

                GiftItemView.getFormattedCode = function (code) {
                    return (code && code.length == 13) ? code.substring(0, 4) + "-" + code.substring(4, 8) + "-"
                        + code.substring(8, 12) + "-" + code.substring(12) : code;
                }

                GiftItemView.prototype.getModel = function () {
                    if (this.giIndex != -1) {
                        return GiftItemData.getByIndex(this.giIndex);
                    }
                    return null;
                }

                GiftItemView.prototype.loadDataFrom = function (giftItem) {
                    //Assume here than the object in parameter contains only id (must load them)
                    if (giftItem) {
                        if (giftItem.code)
                            this.code = GiftItemView.getFormattedCode(giftItem.code);
                        if (giftItem.service && this.posView)
                            this.serviceView = this.posView.domainView.getServiceView(giftItem.service);
                        this.price = giftItem.price;
                        if (giftItem.vatCode) {
                            this.vat = giftItem.vat;
                            this.vatCode = giftItem.vatCode;
                        } else {
                            if (this.saleView) {
                                this.vat = this.saleView.vat;
                                this.vatCode = this.saleView.vatCode;
                            }
                        }

                        this.isUsed = giftItem.isUsed;
                        this.isCanceled = giftItem.isCanceled;
                        if (giftItem.closingDate) {
                            this.closingDate = giftItem.closingDate;
                        }
                        this.updatePriceHT();
                        if (giftItem.originalPrice != null)
                            this.originalPrice = giftItem.originalPrice;
                        else
                            this.originalPrice = this.price;
                        this.originalPriceInput = $filter('currencyFormatFilter')(this.originalPrice);
                        this.discountPercent = giftItem.discountPercent;
                        if (giftItem.humanResource && this.posView)
                            this.hrView = this.posView.domainView.getHrView(giftItem.humanResource);
                        this.validityDate = giftItem.validityDate;
                        if (this.validityDate)
                            this.validityDateStr = $filter('date')(this.validityDate, 'shortDate');

                        this.editionType = giftItem.editionType;
                        if (giftItem.customer && this.posView)
                            this.customerView = this.posView.domainView.getCustomerView(giftItem.customer);
                        this.barcodeData = giftItem.barcodeData;
                        this.message = giftItem.message;
                        this.messageTitle = giftItem.messageTitle;
                        this.imageUrl = giftItem.imageUrl;
                        this.comment = giftItem.comment;
                        this.updateCustomerLabel();
                    }
                }

                GiftItemView.prototype.updateCustomerLabel = function ()//
                {
                    if (this.customerView) {
                        this.customerLabel = this.customerView.lastName;
                        if (this.customerView.firstName)
                            this.customerLabel = +" " + this.customerView.firstName;

                    } else
                        this.customerLabel = "";
                };

                GiftItemView.prototype.updateFromModel = function () {
                    var giftItem = this.getModel();
                    if (giftItem)
                        this.loadDataFrom(giftItem);
                };

                GiftItemView.prototype.copyDataTo = function (giftItem) {
                    if (giftItem) {
                        if (this.serviceView)
                            giftItem.service = this.serviceView.getModel();
                        giftItem.price = this.price;
                        giftItem.vat = this.vat;
                        giftItem.vatCode = this.vatCode;
                        giftItem.isUsed = this.isUsed;
                        giftItem.isCanceled = this.isCanceled;
                        if (this.closingDate) {
                            giftItem.closingDate = this.closingDate
                        }
                        giftItem.originalPrice = this.originalPrice;
                        if (this.discountPercent && typeof this.discountPercent === 'string') {
                            giftItem.discountPercent = this.discountPercent.replace(",", ".").replace(" ", "");
                            giftItem.discountPercent = parseFloat(giftItem.discountPercent);
                        } else
                            giftItem.discountPercent = this.discountPercent;
                        if (this.code)
                            giftItem.code = this.code.replace(/-/g, "");
                        var newSale = this.saleView.getModel();
                        if (giftItem.sale && newSale !== giftItem.sale)//remove
                            giftItem.sale.removeGiftItem(giftItem);
                        if (newSale)//Force add because removed by sale.updateModel
                            newSale.addGiftItem(giftItem);
                        if (this.hrView)
                            giftItem.humanResource = this.hrView.getModel();
                        giftItem.validityDate = this.validityDate;
                        giftItem.editionType = this.editionType;
                        if (this.customerView) {
                            var customer = this.customerView.getModel();
                            if (customer !== giftItem.customer) {
                                if (giftItem.customer) {
                                    giftItem.customer.removeGiftItem(giftItem);
                                    if (this.posView) {
                                        var previousCustomerView = this.posView.domainView.getCustomerView(giftItem.customer);
                                        if (previousCustomerView)
                                            previousCustomerView.initGiftItemsView();
                                    }
                                }
                                if (customer)
                                    customer.addGiftItem(giftItem);
                                giftItem.customer = customer;
                            }
                            this.customerView.initGiftItemsView();
                        } else {
                            if (giftItem.customer) {
                                giftItem.customer.removeGiftItem(giftItem);
                                if (this.posView) {
                                    var previousCustomerView = this.posView.domainView.getCustomerView(giftItem.customer);
                                    if (previousCustomerView)
                                        previousCustomerView.initGiftItemsView();
                                }
                            }
                            giftItem.customer = null;
                        }
                        giftItem.barcodeData = this.barcodeData;
                        giftItem.message = this.message;
                        giftItem.messageTitle = this.messageTitle;
                        giftItem.imageUrl = this.imageUrl;
                        giftItem.comment = this.comment;
                    }
                };

                GiftItemView.prototype.getClone = function (saleView) {
                    var spView = new GiftItemView(null, -1, this.billPosition, saleView);
                    spView.vatCode = this.vatCode;
                    spView.vat = this.vat;
                    spView.serviceView = this.serviceView;
                    spView.code = this.code;
                    spView.price = this.price;
                    spView.originalPrice = this.originalPrice;
                    spView.originalPriceInput = this.originalPriceInput;
                    spView.discountPercent = this.discountPercent;
                    spView.hrView = this.hrView;
                    spView.isUsed = this.isUsed;
                    spView.isCanceled = this.isCanceled;
                    if (this.closingDate) {
                        spView.closingDate = this.closingDate;
                    }
                    spView.validityDate = this.validityDate;
                    spView.editionType = this.editionType;
                    spView.comment = this.comment;
                    spView.customerView = this.customerView;
                    spView.updateCustomerLabel();
                    return spView;
                };

                GiftItemView.prototype.canceled = function (callbackFunction) {
                    var msgConfirmation = gettextCatalog.getString("Voulez-vous vraiment clôturer ce chèque cadeau valable jusqu'au");
                    var msgWarning = gettextCatalog.getString("Attention, cette opération ne peut pas être annulée");

                    var gi = this;
                    var opts = {
                        backdrop: true,
                        keyboard: true,
                        backdropClick: false,
                        templateUrl: '/partials/global/generalConfirm.html',
                        controller: 'DialogCtrl',
                        resolve: {
                            dialogsModel: function () {
                                var tableModel = [];
                                tableModel["question"] = msgConfirmation + " " + (gi.validityDateStr ? gi.validityDateStr : "") + " ?";
                                tableModel["description"] = msgWarning;
                                return tableModel;
                            }
                        }
                    };

                    var d = $dialog.dialog(opts);
                    d.open().then(function (result) {
                        if (result) {
                            gi.isCanceled = true;
                            gi.closingDate = new Date();
                            gi.updateModel(true, callbackFunction);

                            if (gi.posView && gi.posView.posSaleHistoryView) {
                                gi.posView.posSaleHistoryView.onSearchGiftItemInputKeyDown(gi.posView.posSaleHistoryView.filters.type);
                            }
                        }
                    });
                };

                GiftItemView.prototype.updateOriginalPriceInputArrow = function (number) {
                    if ((!this.saleView || !this.saleView.isReadOnly) && this.originalPriceInput != null && typeof this.originalPriceInput === 'string') {
                        var originalPriceStr = CurrencyManager.getPriceFromPriceInput(this.originalPriceInput);
                        var originalPrice = parseFloat(originalPriceStr);
                        if (originalPrice !== "NaN")
                            originalPrice += number;

                        this.originalPriceInput = $filter('currencyFormatFilter')(originalPrice);
                        this.originalPrice = originalPrice;
                        this.updatePrice();
                    }
                }

                GiftItemView.prototype.onOriginalPriceInputChange = function () {
                    if ((!this.saleView || !this.saleView.isReadOnly) && this.originalPriceInput != null && typeof this.originalPriceInput === 'string') {
                        let originalPriceStr = CurrencyManager.getPriceFromPriceInput(this.originalPriceInput);
                        let originalPrice = parseFloat(originalPriceStr);
                        if (originalPrice !== "NaN") {
                            this.originalPrice = originalPrice;
                        } else {
                            this.originalPrice = null;
                        }
                        this.updatePrice();
                    }
                };

                GiftItemView.prototype.setHrView = function (hrView) {
                    this.hrView = hrView;
                };
                GiftItemView.prototype.updatePriceHT = function () {
                    // no vat
                    this.priceHT = this.price;
                };
                GiftItemView.prototype.increaseDiscountPercent = function (step) {
                    if (this.saleView && !this.saleView.isReadOnly) {
                        if ((step + this.discountPercent) > 100)
                            this.discountPercent = 100;
                        else
                            this.discountPercent += step;
                        this.updatePrice();
                    }

                }
                GiftItemView.prototype.decreaseDiscountPercent = function (step) {
                    if (this.saleView && !this.saleView.isReadOnly) {
                        if (this.discountPercent - step < 0)
                            this.discountPercent = 0;
                        else
                            this.discountPercent -= step;
                        this.updatePrice();
                    }

                };

                GiftItemView.prototype.updatePrice = function () {
                    var oriPrice = this.originalPrice;
                    var discount = 0;
                    var discountPercent = this.discountPercent;
                    if (this.discountPercent && typeof this.discountPercent === 'string') {
                        discountPercent = this.discountPercent.replace(",", ".").replace(" ", "");
                        discountPercent = parseFloat(discountPercent);
                    }
                    if (discountPercent != 0)
                        discount = Math.round((discountPercent * oriPrice / 100) * 100) / 100;

                    if ((oriPrice - discount) != this.price) {
                        this.price = (oriPrice - discount);
                        this.updatePriceHT();
                        if (this.saleView) {
                            this.saleView.resetPayments();
                            this.saleView.calculateSaleFields();
                        }
                    }
                    this.saleView.checkForInvalidAmounts();
                }

                GiftItemView.prototype.onCustomerInputKeyDown = function (event) {
                    var keyCode = event.which;
                    //if key delete detected : clear customer
                    if (keyCode == 8 || keyCode == 46)
                        this.customerView = null;
                }

                GiftItemView.prototype.updateEditionType = function (type, save) {
                    this.editionType = type;
                    this.updateModel(save);
                }

                GiftItemView.prototype.updateModel = function (save, endFunction) {
                    if (this.customerView) {
                        if (this.posView && !this.customerView.getModel())//Add to view
                        {
                            this.posView.domainView.addCustomerView(this.customerView);
                        }
                        this.customerView.updateModel(false);
                    }
                    var giftItem = this.getModel();
                    if (giftItem == null) {
                        giftItem = new GiftItem();
                        this.giIndex = GiftItemData.getIndexOf(giftItem);
                    }
                    this.copyDataTo(giftItem);
                    var giftItemView = this;
                    if (save !== undefined && save)//save directly in order to get id
                        GiftItemSrv.save(giftItem, function () {
                            if (giftItem.code) {
                                giftItemView.code = GiftItemView.getFormattedCode(giftItem.code);
                                if (endFunction != undefined) {
                                    endFunction();
                                }
                            }
                        })
                }

                GiftItemView.prototype.canSave = function () {
                    if (!this.productView) {
                        return false;
                    }

                    var priceFloat = parseFloat(this.price);
                    if (priceFloat !== "NaN" && priceFloat !== "") {
                        this.price = priceFloat;
                    } else {
                        this.price = "";
                    }
                    return (this.label && this.label != "") && (this.price && this.price >= 0);
                }

                GiftItemView.prototype.sendMail = function () {
                    let giftItem = this.getModel();
                    if (giftItem && this.canSendGiftItemMail()) {
                        GiftItemSrv.sendMail(giftItem);
                    }
                };

                GiftItemView.prototype.canSendGiftItemMail = function () {
                    let canSendMail = true;

                    if (!this.hasCustomerWithEmail() && !this.saleView.hasCustomerWithEmail()) {
                        canSendMail = false;
                    }

                    return canSendMail;
                };

                GiftItemView.prototype.hasCustomerWithEmail = function () {
                    return this.customerView && this.customerView.email;
                };

                GiftItemView.prototype.getCustomerOfSale = function () {
                    var customerOfSale = null;
                    if (this.saleView &&
                        this.saleView.customerView &&
                        this.saleView.customerView.getModel()) {
                        customerOfSale = this.saleView.customerView.getModel();
                    }
                    return customerOfSale;
                }

                return GiftItemView;
            }
        ]);



// WEBPACK FOOTER //
// ./js/services/views/GiftItemView.js